// extracted by mini-css-extract-plugin
export default {"receipt_image":"billcard_receipt_image__HpUkJ"};